import { Box, Image, Input, Stack, Text } from '@chakra-ui/react';
import { MutableRefObject, useEffect, useState } from 'react';

import facebookLogo from '../../assets/whiteLabelImage/facebook-logo.png';
import instagramLogo from '../../assets/whiteLabelImage/instagram-logo.png';
import linkedinLogo from '../../assets/whiteLabelImage/linkedin-logo.png';
import twitterLogo from '../../assets/whiteLabelImage/twitter-logo.png';
import youtubeLogo from '../../assets/whiteLabelImage/youtube-logo.png';
import { StepsFormActions } from '../../contexts/StepsContext';
import { useStepsForm } from '../../hooks/useStepsForm';
import { api } from '../../services/api';
import { BoxCritical } from './BoxCritical';

interface Props {
  linkInputFacebook: MutableRefObject<HTMLInputElement>;
  linkInputInstagram: MutableRefObject<HTMLInputElement>;
  linkInputTwitter: MutableRefObject<HTMLInputElement>;
  linkInputYoutube: MutableRefObject<HTMLInputElement>;
  linkInputLinkedin: MutableRefObject<HTMLInputElement>;
  criticaFacebook: string;
  criticaTwitter: string;
  criticaInstagram: string;
  criticaYoutube: string;
  criticaLinkedin: string;
}

export const SocialMediaRow = ({
  linkInputFacebook,
  linkInputInstagram,
  linkInputTwitter,
  linkInputYoutube,
  linkInputLinkedin,
  criticaFacebook,
  criticaTwitter,
  criticaInstagram,
  criticaYoutube,
  criticaLinkedin
}: Props): JSX.Element => {
  const { state, setState } = useStepsForm();

  return (
    <>
      <Stack mb="26px">
        <Box display="flex" alignItems="center" gridGap="15px">
          <Image
            h={'55.66px'}
            w={'56px'}
            src={facebookLogo}
            alt={'facebook-logo'}
          />
          <Box width="100%">
            <Text
              fontSize="1rem"
              fontWeight="400"
              lineHeight="1.5rem"
              color="#1F1E1F"
            >
              Facebook
            </Text>
            <Input
              id={'Copie e cole o link do seu perfil do Facebook aqui'}
              ref={linkInputFacebook}
              value={state.profileFacebook}
              mt="10px"
              type="text"
              onChange={(e) => {
                setState({
                  type: StepsFormActions.setProfileFacebook,
                  payload: e.target.value
                });
              }}
              maxW="400px"
              h="50px"
              borderRadius="6px"
              bg="#FFFFFF"
              border="1px solid #001E64 !important"
              placeholder={'Copie e cole o link do seu perfil do Facebook aqui'}
              _placeholder={{
                color: '#828282',
                fontSize: '1rem',
                fontWeight: '400',
                lineHeight: '1.5rem'
              }}
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            />
          </Box>
        </Box>
        {criticaFacebook ? (
          <BoxCritical maxWidth={'468px'} textContent={criticaFacebook} />
        ) : undefined}
      </Stack>
      <Stack mb="26px !important">
        <Box display="flex" alignItems="center" gridGap="15px">
          <Image
            h={'55.66px'}
            w={'56px'}
            src={twitterLogo}
            alt={'Twitter-logo'}
          />
          <Box width="100%">
            <Text
              fontSize="1rem"
              fontWeight="400"
              lineHeight="1.5rem"
              color="#1F1E1F"
            >
              Twitter
            </Text>
            <Input
              id={'Copie e cole o link do seu perfil do Twitter aqui'}
              ref={linkInputTwitter}
              value={state.profileTwitter}
              mt="10px"
              type="text"
              onChange={(e) => {
                setState({
                  type: StepsFormActions.setProfileTwitter,
                  payload: e.target.value
                });
              }}
              maxW="400px"
              h="50px"
              borderRadius="6px"
              bg="#FFFFFF"
              border="1px solid #001E64 !important"
              placeholder={'Copie e cole o link do seu perfil do Twitter aqui'}
              _placeholder={{
                color: '#828282',
                fontSize: '1rem',
                fontWeight: '400',
                lineHeight: '1.5rem'
              }}
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            />
          </Box>
        </Box>
        {criticaTwitter ? (
          <BoxCritical maxWidth={'468px'} textContent={criticaTwitter} />
        ) : undefined}
      </Stack>
      <Stack mb="26px !important">
        <Box display="flex" alignItems="center" gridGap="15px">
          <Image
            h={'55.66px'}
            w={'56px'}
            src={instagramLogo}
            alt={'Instagram-logo'}
          />
          <Box width="100%">
            <Text
              fontSize="1rem"
              fontWeight="400"
              lineHeight="1.5rem"
              color="#1F1E1F"
            >
              Instagram
            </Text>
            <Input
              id={'Copie e cole o link do seu perfil do Instagram aqui'}
              ref={linkInputInstagram}
              value={state.profileInstagram}
              mt="10px"
              type="text"
              onChange={(e) => {
                setState({
                  type: StepsFormActions.setProfileInstagram,
                  payload: e.target.value
                });
              }}
              maxW="400px"
              h="50px"
              borderRadius="6px"
              bg="#FFFFFF"
              border="1px solid #001E64 !important"
              placeholder={
                'Copie e cole o link do seu perfil do Instagram aqui'
              }
              _placeholder={{
                color: '#828282',
                fontSize: '1rem',
                fontWeight: '400',
                lineHeight: '1.5rem'
              }}
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            />
          </Box>
        </Box>
        {criticaInstagram ? (
          <BoxCritical maxWidth={'468px'} textContent={criticaInstagram} />
        ) : undefined}
      </Stack>
      <Stack mb="26px !important">
        <Box display="flex" alignItems="center" gridGap="15px">
          <Image
            h={'55.66px'}
            w={'56px'}
            src={youtubeLogo}
            alt={'Youtube-logo'}
          />
          <Box width="100%">
            <Text
              fontSize="1rem"
              fontWeight="400"
              lineHeight="1.5rem"
              color="#1F1E1F"
            >
              Youtube
            </Text>
            <Input
              id={'Copie e cole o link do seu perfil do Youtube aqui'}
              ref={linkInputYoutube}
              value={state.profileYoutube}
              mt="10px"
              type="text"
              onChange={(e) => {
                setState({
                  type: StepsFormActions.setProfileYoutube,
                  payload: e.target.value
                });
              }}
              maxW="400px"
              h="50px"
              borderRadius="6px"
              bg="#FFFFFF"
              border="1px solid #001E64 !important"
              placeholder={'Copie e cole o link do seu perfil do Youtube aqui'}
              _placeholder={{
                color: '#828282',
                fontSize: '1rem',
                fontWeight: '400',
                lineHeight: '1.5rem'
              }}
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            />
          </Box>
        </Box>
        {criticaYoutube ? (
          <BoxCritical maxWidth={'468px'} textContent={criticaYoutube} />
        ) : undefined}
      </Stack>
      <Stack>
        <Box display="flex" alignItems="center" gridGap="15px">
          <Image
            h={'55.66px'}
            w={'56px'}
            src={linkedinLogo}
            alt="Linkedin Logo"
          />
          <Box width="100%">
            <Text
              fontSize="1rem"
              fontWeight="400"
              lineHeight="1.5rem"
              color="#1F1E1F"
            >
              Linkedin
            </Text>
            <Input
              id={
                'Copie e cole o link do seu perfil do seu perfil do Linkedin aqui'
              }
              ref={linkInputLinkedin}
              value={state.profileLinkedin}
              mt="10px"
              type="text"
              onChange={(e) => {
                setState({
                  type: StepsFormActions.setProfileLinkedin,
                  payload: e.target.value
                });
              }}
              maxW="400px"
              h="50px"
              borderRadius="6px"
              bg="#FFFFFF"
              border="1px solid #001E64 !important"
              placeholder={
                'Copie e cole o link do seu perfil do seu perfil do Linkedin aqui'
              }
              _placeholder={{
                color: '#828282',
                fontSize: '1rem',
                fontWeight: '400',
                lineHeight: '1.5rem'
              }}
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            />
          </Box>
        </Box>
        {criticaLinkedin ? (
          <BoxCritical maxWidth={'468px'} textContent={criticaLinkedin} />
        ) : undefined}
      </Stack>
    </>
  );
};
